import {
	EMPLOYEE_ROLES_MAPPING,
	EMPLOYEE_ROLES_MAPPING_LONG,
	EEmployeeRole,
	EmployeeProperties,
} from "../types/employee.type";
import { EmployeeRoleProperties } from "../types/employeeRole.type";

const renderRoles = (roles: EEmployeeRole[], filteredRoles?: EEmployeeRole[]) => {
	if (filteredRoles) {
		roles = roles.filter((role) => filteredRoles.includes(role));
	}
	return roles
		.map((role) => {
			if (EMPLOYEE_ROLES_MAPPING[role]) {
				return EMPLOYEE_ROLES_MAPPING[role];
			} else {
				return null;
			}
		})
		.filter(Boolean)
		.join(", ");
};
const renderRolesLong = (roles: EEmployeeRole[], filteredRoles?: string[]) => {
	if (filteredRoles) {
		roles = roles.filter((role) => filteredRoles.includes(role));
	}
	return roles
		.map((role) => {
			if (EMPLOYEE_ROLES_MAPPING_LONG[role]) {
				return EMPLOYEE_ROLES_MAPPING_LONG[role];
			} else {
				return null;
			}
		})
		.filter(Boolean)
		.join(", ");
};

const renderRolesWithOffice = (employees: EmployeeProperties[], filteredRoles?: EEmployeeRole[]) => {
	const x = employees
		.map(
			(emp) =>
				`${emp.office?.officeName} (${emp.employeeRole
					?.filter((role) => filteredRoles?.includes(role.role))
					.map(({ role }) => {
						if (EMPLOYEE_ROLES_MAPPING[role]) {
							return EMPLOYEE_ROLES_MAPPING[role];
						} else {
							return null;
						}
					})
					.filter(Boolean)
					.join(", ")})`
		)
		.filter(Boolean)
		.join(", ");
	return x;
};

const checkRoles = (empRole: EmployeeRoleProperties[], ...findRoles: EEmployeeRole[]) => {
	let roles = empRole.map((role) => role.role);
	let find = findRoles.find((role) => roles.includes(role));

	return find !== undefined;
};
export { renderRoles, renderRolesLong, renderRolesWithOffice, checkRoles };
